import type { PageInfo, PageType } from "../types/types";

export const getPageInfo = (
  pageType: PageType,
  pageUrl: string,
  language: string,
): PageInfo => {
  return {
    httpStatusCode: 200,
    pageLanguage: language.toUpperCase(),
    pageType: pageType,
    pageUrl: pageUrl,
    canonicalPageUrl: undefined,
  };
};
